import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ClientMyPageProjectView } from '@/components/pages/mypage/client/ClientMyPageProjectView';
import ModalSelector from '@/container/Client/MyPage/Project/ModalSelector';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { useClientMyPageProject } from '@/pages/mypage/client/ClientMyPageProject/useClientMyPageProject';
import { useClientMyPageProjectRfp } from '@/pages/mypage/client/ClientMyPageProject/useClientMyPageProjectRfp';
import SolutionTable from '../../../../container/Client/MyPage/Project/Solution/SolutionTable';
import Layout from '../../../../container/Layout';
const scrollTargetId = 'ClientMyPageProjectProjectBody';
/**
 * @param props
 * @constructor
 */
export const ClientMyPageProject = (props) => {
    const { location, match, profile } = props;
    // データ取得, タブ + ページネーションの管理
    const { onChangePage, onClickTab, rfpLoading, rfpsPaging, solutionsLoading, solutionsPaging, tab, } = useClientMyPageProject({
        location,
        match,
        scrollTargetId,
    });
    const { rfp_unread_count: rfpUnreadCount } = useTypeSelector((state) => state.clientRfpCount);
    // 提案募集中の案件 データ整形
    const { rfpTableData } = useClientMyPageProjectRfp({
        profile,
        rfpsPaging,
    });
    // TODO: Layout は TS化したら ClientMyPageProjectView に移す
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main' }, { children: [_jsx(ClientMyPageProjectView, { activeTabValue: tab, onChangeRfpPage: onChangePage, onClickTab: onClickTab, rfpLoading: rfpLoading, rfpTableData: rfpTableData, rfpUnreadCount: rfpUnreadCount, scrollTargetId: scrollTargetId, solutionTable: _jsx("div", Object.assign({ className: clsx('project_body', '!p-0') }, { children: _jsx(SolutionTable, { loading: solutionsLoading, onPageChange: onChangePage, page: solutionsPaging }) })) }), _jsx(ModalSelector, {})] })));
};
